import fancybox from '../fancybox';

const $automotiveItemDetail = $('.js-automotive-item-details');
const $automotiveItems = $('.js-automotive-item');

$automotiveItemDetail.click((event) => {
  const $this = $(event.currentTarget);
  const $automotiveItem = $this.parents('.js-automotive-item');

  $automotiveItems.removeClass('is-active');
  $automotiveItem.addClass('is-active');
});

// Video Fancybox
fancybox.applyFancyBoxVideo($('.automotive__intro .video-thumbnail'));
fancybox.applyFancyBoxVideo($('.automotive__video .video-thumbnail'));
fancybox.applyFancyBoxVideo($('.automotive__small-device .video-thumbnail'));
fancybox.applyFancyBoxVideo($('.video-widget .video-thumbnail'));
